
define(
	'BTM.SEOFix.SEOFix'
,   [
		'underscore',
		'SC.Configuration',
		'jQuery',
		'Handlebars',
		'Utils',
		'Home.View'
	]
,   function (
		_,
		Configuration,
		jQuery,
		Handlebars,
		Utils,
		HomeView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			_.extend(HomeView.prototype, {
				initSlider: function initSlider() {
					Utils.initBxSlider(this.$('[data-slider]'), {
						nextText: '<a class="home-gallery-next-icon" aria-hidden="true"></a>',
						prevText: '<a class="home-gallery-prev-icon" aria-hidden="true"></a>'
					});
				}
			});
		}
	};
});
